namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerEditor()
    export class VatRefundDocFgLookupcustom extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, any> {

        public myId: string;
        public myId2: string;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return this.buildLookupKey(this.myId,this.myId2);
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var customLookup = Q.getLookup(this.buildLookupKey(this.myId,this.myId2));

            let items: any = super.getItems(customLookup);

            // this is demo about filtering lookup items

            // only take item that has Id % 5 = 0 (5, 10, 15, 20...)
            // items = items.filter(x => Q.toId(x.Id) % 5 == 0); // here 'Id' field is hardcode for demo
            items = items.filter(x => Q.toId(x.ShopId) == this.myId2); // here 'Id' field is hardcode for demo

            // just take maximum first 5 items
            // if (items.length >= 5) {
            //     return items.slice(0, 5);
            // }
            // else {
                return items;
            // }
        }

        private buildLookupKey(id?: string,id2?: string): string {

            //demo switch lookup key by id

            if (id == "0") {


                return "PosShift.LookupRecieptforVatRefund";

            } else {
            //     if (id == 200) {
                    return "PosShift.LookupTaxInvoiceforVatRefund";
            //     }
            //     else {
            //         return "Supplier.Supplier"; // default
            //     }
            }
        }
    }    
}